import React, { ComponentType } from "react";
import withErrorBoundary, {
  WithErrorBoundaryConfig,
} from "./withErrorBoundary";

// eslint-disable-next-line @typescript-eslint/ban-types
const withErrorBoundaryHOC =
  <P extends object>(
    WrappedComponent: ComponentType<P>,
    config?: WithErrorBoundaryConfig
  ) =>
  (props: P) =>
    withErrorBoundary(<WrappedComponent {...props} />, config);

export type WithErrorBoundaryHOC<WrappedComponentProps> = WrappedComponentProps;

export default withErrorBoundaryHOC;
